/* rb-d-pdp.js -- DESKTOP (>= 768px) denim buying flow. 23 Sep 2026.

   Two of the mobile changes Mark picked for desktop:

   4. Quick-add on a fit card (Zach, Graduate ...): the hover tray says
      "Select size" and offers a select of 18 NNxNN sizes, most of them
      "-- sold out", AFTER the shopper has committed to a wash by hovering a
      swatch. The phone's wash sheet shows what is in stock per wash before
      that. Desktop gets the same line in the tray, for the wash currently
      shown: "Ice Chalk Twill . Waist 32 . 33 . 34" or "Only 2 left . 32x30,
      33x32". Data is the card's own compact variant map (RBM.qaShared).

   5. Denim PDP: waist -> inseam chips instead of the 18-cell grid, and no
      pre-picked size (Add to cart reads "Select size" until the shopper
      picks; Buy with Shop hidden until then). Same function as the phone
      (RBM.pdpShared.pdpDenim), same guards.

   Runs only above 767px (RBM.onDesktop). */
(function () {
  'use strict';
  if (!window.RBM || !RBM.onDesktop) return;

  /* 5 -- denim PDP */
  RBM.onDesktop('d-pdp-denim', function () {
    if (RBM.pdpShared && RBM.pdpShared.pdpDenim) RBM.pdpShared.pdpDenim();
  });

  /* 4 -- stock line in the quick-add tray */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* sold-out sizes to the bottom of the size select and the pill row (Mark,
     29 Sep). Option B rebuilds both when the wash changes; the tray observer
     below re-runs this, and a second pass is a no-op once sorted. The empty
     "Size" placeholder stays first. */
  function sortSizes(ov) {
    var q = RBM.qaShared; if (!q || !q.sortSoldOut) return;
    Array.prototype.forEach.call(ov.querySelectorAll('select.js-rb-qa-select, select.rb-qa-select'), function (sel) {
      var cur = sel.value;
      var opts = Array.prototype.filter.call(sel.options, function (o) { return o.value; });
      if (q.sortSoldOut(sel, opts, function (o) { return o.disabled || /sold\s*out/i.test(o.textContent); }, function (o) { return o.textContent; })) sel.value = cur;
    });
    var pills = ov.querySelector('.quick-add-overlay__pills');
    if (pills) q.sortSoldOut(pills, Array.prototype.slice.call(pills.querySelectorAll('.js-quick-add-pill')),
      function (b) { return b.disabled; }, function (b) { return b.getAttribute('data-size') || b.textContent; });
  }
  function paintTray(ov) {
    sortSizes(ov);
    var q = RBM.qaShared; if (!q) return;
    var card = ov.closest('.product-card, .js-product-card'); if (!card) return;
    var tray = ov.querySelector('.rb-qa-tray__label'); if (!tray) return;
    var cur = ov.dataset.currentColor || '';
    var rows = q.washes(card);
    var w = rows.filter(function (r) { return r.name === cur; })[0];
    if (!w) {   /* single-colour product: the map rows have no colour; sum them */
      var node = card.querySelector('.js-quick-add-variants'); var map = [];
      try { map = JSON.parse(node.textContent) || []; } catch (e) { map = []; }
      if (!rows.length && map.length) { w = { name: '', avail: 0, n: map.length, sizes: [] }; map.forEach(function (r) { if (r[3]) { w.avail++; if (r[2]) w.sizes.push(String(r[2])); } }); }
    }
    var line = tray.querySelector('.rbd-stock');
    if (!w) { if (line) line.remove(); return; }
    if (!line) { line = document.createElement('span'); line.className = 'rbd-stock'; tray.appendChild(line); }
    var html = !w.avail ? '<span class="rbm-wash__sizes is-low">Sold out in this wash</span>' : q.sizeLine(w.sizes, w.n);
    var key = cur + '|' + html;
    if (line.dataset.key === key) return;
    line.dataset.key = key;
    line.innerHTML = (w.name ? '<b>' + esc(w.name) + '</b>' : '') + html;
  }
  function watchOverlays() {
    Array.prototype.forEach.call(document.querySelectorAll('.js-quick-add-overlay'), function (ov) {
      if (ov.dataset.rbdTray) return;
      ov.dataset.rbdTray = '1';
      paintTray(ov);
      /* the theme's swatch code updates data-current-color; Option B redraws the tray */
      new MutationObserver(RBM.debounce(function () { paintTray(ov); }, 40)).observe(ov, { attributes: true, attributeFilter: ['data-current-color'], childList: true, subtree: true });
    });
  }
  RBM.onDesktop('d-qa-tray', function () {
    if (!window.MutationObserver) return;
    watchOverlays();
    new MutationObserver(RBM.debounce(watchOverlays, 150)).observe(document.body, { childList: true, subtree: true });
  });
})();
